import api from '../../api/sku'
import {
  SKU_LIST,
  UPDATE_SKU
} from '../actions/sku'

const state = {
  skuList: []
}

const getters = {
  skuList: state => state.skuList,
  skuById (state) {
    return id => state.skuList.filter(item => {
      return item.id === parseInt(id)
    })
  }
}

const actions = {
  [SKU_LIST]: async function ({commit, state}) {
    if (state.skuList.length) {
      return 200
    }
    try {
      const res = await api.getAllSku()
      commit(SKU_LIST, res)
      return res.status
    } catch (err) {
      console.log(err)
      return err.response.status
    }
  },
  [UPDATE_SKU]: async function ({commit, state}) {
    try {
      const res = await api.updateSku()
      commit(SKU_LIST, res)
      return res.status
    } catch (err) {
      console.log(err)
      return err.response.status
    }
  }
}

const mutations = {
  [SKU_LIST]: (state, res) => {
    state.skuList = res.data.data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sku.js